<div class="captura-panel">
  <div class="flex justify-between align-center">
    <span class="label">Capturas</span>
    <app-button-padrao
      icon="add"
      width="25px"
      height="25px"
      (buttonClick)="adicionarCaptura()"
    >
    </app-button-padrao>
  </div>

  <div class="flex-direction-col gap-5">
    @for (captura of this.selectedNode?.capturas; track $index) {
    <div
      class="flex-direction-col gap-5 captura-item"
      style="margin-bottom: 15px"
    >
      <div class="flex-direction-row gap-5 align-center justify-between">
        <span class="label">Captura {{ $index + 1 }}</span>
        <mat-icon
          (click)="removerCaptura(captura)"
          class="cursor-pointer color-primary"
          >delete_forever</mat-icon
        >
      </div>
      <div class="flex-direction-row gap-5 align-center justify-center">
        <span
          class="label"
          [ngClass]="
            captura.tipoCaptura === TipoEtapaCaptacaoEnum.PREENCHIMENTO
              ? 'selecionado'
              : ''
          "
        >
          Preenchimento
        </span>

        <mat-slide-toggle
          style="
            transform: rotate(180deg);
            position: relative;
            top: 3px;
            right: 3px;
          "
          [checked]="
            captura.tipoCaptura === TipoEtapaCaptacaoEnum.PREENCHIMENTO
          "
          (change)="
            captura.tipoCaptura = $event.checked
              ? TipoEtapaCaptacaoEnum.PREENCHIMENTO
              : TipoEtapaCaptacaoEnum.REDIRECIONAMENTO
          "
        >
        </mat-slide-toggle>

        <span
          class="label"
          [ngClass]="
            captura.tipoCaptura === TipoEtapaCaptacaoEnum.REDIRECIONAMENTO
              ? 'selecionado'
              : ''
          "
        >
          Redirecionamento
        </span>
      </div>

      <app-form-field
        label="Valor Captura"
        heightFormField="35px"
        placeholder="Valor para ser analisado!"
        [value]="captura.valorCaptura"
        (changeValue)="captura.valorCaptura = $event"
      ></app-form-field>

      @if (captura.tipoCaptura === TipoEtapaCaptacaoEnum.PREENCHIMENTO) {
      <div
        class="flex-direction-col gap-5"
      >
        <app-form-field
          label="Valor Inserção"
          heightFormField="35px"
          placeholder="Valor que será salvo!"
          [value]="captura.valorInsercao"
          (changeValue)="captura.valorInsercao = $event"
        ></app-form-field>

        <app-select-one
          campo="nome"
          widthFormField="100%"
          label="Variável para salvar:"
          heightFormField="35px"
          [listaInput]="variaveisSelect"
          [itemSelecionado]="getVariavelSelecionada(captura)"
          (selecionarItem)="selecionarVariavel($event, captura)"
        >
        </app-select-one>
      </div>
      }

      @if (captura.tipoCaptura === TipoEtapaCaptacaoEnum.REDIRECIONAMENTO) {
      <div>
        <app-select-one
          campo="nome"
          label="Fluxo destino:"
          widthFormField="100%"
          heightFormField="35px"
          [listaInput]="fluxosSelect"
          [itemSelecionado]="getFluxoSelecionado(captura)"
          (selecionarItem)="selecionarFluxo($event, captura)"
        >
        </app-select-one>
      </div>
      }
    </div>
    }
  </div>
</div>
